<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-goods"></i> 低值易耗</span>
      </div>

      <!-- 搜索表单 -->
      <el-form
        :model="queryParams"
        :inline="true"
        label-position="right"
        class="demo-form-inline"
      >
        <!-- 物资类别 -->
        <el-form-item label="物资类别">
          <el-input
            v-model="queryParams.category"
            placeholder="请输入物资类别"
            clearable
            style="width: 250px"
          />
        </el-form-item>

        <!-- 物资名称 -->
        <el-form-item label="物资名称">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入物资名称"
            clearable
            style="width: 250px"
          />
        </el-form-item>
      </el-form>

      <div style="margin-bottom: 20px">
        <el-button type="primary" icon="el-icon-search" @click="handleQuery(1)">
          查询
        </el-button>
        <el-button @click="resetQuery">重置</el-button>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="openAddMaterialDialog"
        >
          新增
        </el-button>
      </div>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column prop="assetsCatName" label="物资类别" fixed />
        <el-table-column prop="consumableAssetsName" label="物资名称" fixed />
        <el-table-column
          prop="providerName"
          label="供应商"
          fixed
        ></el-table-column>
        <el-table-column prop="assetsUnit" label="单位"></el-table-column>
        <el-table-column prop="assetsSku" label="规格"></el-table-column>
        <el-table-column
          prop="inventoryQuantity"
          label="入库数量"
        ></el-table-column>
        <el-table-column
          prop="consumeQuantity"
          label="消耗数量"
        ></el-table-column>
        <el-table-column
          prop="restQuantity"
          label="剩余数量"
        ></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="creatorName" label="创建人"></el-table-column>
        <!-- 操作列 -->
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="openScrapDialog(scope.row)"
              type="danger"
              >报废出库</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />
      <!-- 新增物资弹窗 -->
      <el-dialog
        title="新增物资"
        :visible.sync="materialDialogVisible"
        width="600px"
        @close="resetMaterialForm"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="materialForm"
          :rules="materialRules"
          ref="materialFormRef"
          label-width="100px"
        >
          <el-form-item label="物资类别" prop="assetsCatCode">
            <el-select
              v-model="materialForm.assetsCatCode"
              @change="handleCategoryChange"
              placeholder="请选择物资类别"
              style="width: 400px"
            >
              <el-option
                v-for="item in categoryOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="物资名称" prop="consumableAssetsName">
            <el-input
              v-model="materialForm.consumableAssetsName"
              style="width: 400px"
            />
          </el-form-item>

          <el-form-item label="供应商" prop="providerCode">
            <el-select
              v-model="materialForm.providerCode"
              @change="handleProviderChange"
              placeholder="请选择供应商"
              style="width: 400px"
            >
              <el-option
                v-for="item in supplierList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="单位" prop="assetsUnit">
            <el-input
              v-model="materialForm.assetsUnit"
              placeholder="请输入单位"
              style="width: 400px"
            />
          </el-form-item>

          <el-form-item label="规格" prop="assetsSku">
            <el-input v-model="materialForm.assetsSku" style="width: 400px" />
          </el-form-item>

          <el-form-item label="预警值" prop="alarmNum">
            <el-input
              v-model="materialForm.alarmNum"
              type="number"
              placeholder="请输入预警值"
              style="width: 400px"
            />
          </el-form-item>

          <el-form-item label="入库数量" prop="inventoryQuantity">
            <el-input
              v-model="materialForm.inventoryQuantity"
              type="number"
              placeholder="请输入入库数量"
              style="width: 400px"
            />
          </el-form-item>

          <el-form-item label="备注" prop="remark">
            <el-input v-model="materialForm.remark" style="width: 400px" />
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="materialDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveMaterial">保存</el-button>
        </div>
      </el-dialog>

      <!-- 报废出库 -->
      <el-dialog
        title="报废出库"
        :visible.sync="scrapDialogVisible"
        width="600px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="scrapForm"
          :rules="scrapRules"
          ref="scrapFormRef"
          label-width="100px"
        >
          <!-- 物资名称 -->
          <el-form-item label="物资名称" prop="name">
            <el-input
              v-model="scrapForm.name"
              placeholder="请输入物资名称"
              style="width: 400px"
            >
            </el-input>
          </el-form-item>

          <!-- 可用数量 -->
          <el-form-item label="剩余数量" prop="restQuantity">
            <el-input
              v-model="scrapForm.restQuantity"
              disabled
              style="width: 400px"
            />
          </el-form-item>
          <!-- 数量 -->
          <el-form-item label="报废数量" prop="count">
            <el-input-number
              v-model="scrapForm.count"
              style="width: 400px"
              placeholder="请输入数量"
              :min="1"
              :step="1"
            />
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="scrapDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitScrap">提交</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  consumableAssetsList,
  assetsCategoryPage,
  addConsumableAssets,
  submitScrapAssets,
  getAllApproveSteps,
} from "@/api/material";
import { mapState } from "vuex";
import PaginationBar from "@/components/PaginationBar";

export default {
  components: {
    PaginationBar,
  },
  computed: {
    ...mapState(["supplierList"]), // 从 Vuex 获取 userPermissions
  },
  data() {
    return {
      queryParams: {
        category: "",
        name: "",
      },
      // 报废的form
      scrapForm: {
        name: "",
        restQuantity: "",
        count: "",
      },
      total: 0,
      pageSize: 10,
      currentPage: 1,
      materialDialogVisible: false,
      materialForm: {
        assetsCatCode: "",
        consumableAssetsName: "",
        providerCode: "",
        assetsUnit: "",
        assetsSku: "",
        inventoryQuantity: 1,
        alarmNum: "", //预警值
        remark: "",
        providerName: "",
        assetsCatName: "",
      },
      tableData: [],
      materialRules: {
        assetsCatCode: [
          { required: true, message: "请选择物资类别", trigger: "blur" },
        ],
        consumableAssetsName: [
          { required: true, message: "请输入物资名称", trigger: "blur" },
        ],
        providerCode: [
          { required: false, message: "请选择供应商", trigger: "blur" },
        ],
        assetsUnit: [
          { required: true, message: "请选择单位", trigger: "blur" },
        ],
        assetsSku: [
          { required: false, message: "请输入规格", trigger: "blur" },
        ],
        alarmNum: [
          { required: true, message: "请输入预警值", trigger: "blur" },
        ],
        inventoryQuantity: [
          { required: true, message: "请输入入库数量", trigger: "blur" },
        ],
      },
      categoryOptions: [],
      scrapDialogVisible: false, // 控制弹窗的显示
      scrapRules: {
        name: [
          { required: true, message: "请选择物资名称", trigger: "change" },
        ],
        count: [{ required: true, message: "请输入数量", trigger: "blur" }],
        reason: [
          { required: true, message: "请输入报废缘由", trigger: "blur" },
        ],
      },
      approveStepList: [], //审批流
    };
  },
  created() {
    this.handleQuery();
    this.getAllInventory();
  },
  methods: {
    getApprove() {
      getAllApproveSteps({
        approvalTypeId: "1926833536500051969", // 固定参数,低值易耗申领参数
      }).then((res) => {
        this.approveStepList = res || [];
      });
    },
    // 提交报废出库
    submitScrap() {
      // 手动校验数量是否超过最大数量
      if (this.scrapForm.count > this.scrapForm.restQuantity) {
        this.$message.error(
          `数量不能超过最大数量 ${this.scrapForm.restQuantity}`
        );
        return; // 如果数量不合法，直接返回，不提交数据
      }

      // 表单验证
      this.$refs.scrapFormRef.validate((valid) => {
        if (valid) {
          console.log("报废出库数据:", this.scrapForm, this.approveStepList);
          // 调用接口保存数据
          // this.scrapDialogVisible = false;

          const params = {
            consumableAssetsId: this.scrapForm.consumableAssetsId,
            consumeQuantity: this.scrapForm.count, //
            remark: "后台操作",
            approveStepList: this.approveStepList,
          };

          submitScrapAssets(params).then(() => {
            this.scrapDialogVisible = false;
            this.$message.success("操作成功");
            this.handleQuery();
          });
        } else {
          return false;
        }
      });
    },
    openScrapDialog(row) {
      this.scrapForm.name = row.consumableAssetsName;
      this.scrapForm.restQuantity = row.restQuantity;
      this.scrapForm.consumableAssetsId = row.consumableAssetsId;
      this.scrapDialogVisible = true;
      // 请求出库审批流程
      this.getApprove();
    },
    handleProviderChange(value) {
      const supplier = this.supplierList.find((item) => item.id === value);
      if (supplier) {
        // 设置名称字段
        this.materialForm.providerName = supplier.name;
      } else {
        this.materialForm.providerName = "";
      }
    },
    handleCategoryChange(value) {
      // 根据选中的物资ID 更新名称
      const selectedCategory = this.categoryOptions.find(
        (item) => item.id === value
      );
      if (selectedCategory) {
        // 设置名称字段
        this.materialForm.assetsCatName = selectedCategory.name;
      } else {
        this.materialForm.assetsCatName = "";
      }
    },
    getAllInventory() {
      assetsCategoryPage({
        pageNo: 1,
        pageSize: 1000,
        category: "低值易耗", //
      }).then((res) => {
        // console.log('res',res)
        this.categoryOptions = res.records;
      });
    },
    openAddMaterialDialog() {
      this.materialDialogVisible = true;
    },
    resetMaterialForm() {
      this.$refs.materialFormRef.resetFields();
    },
    // 新增
    saveMaterial() {
      this.$refs.materialFormRef.validate((valid) => {
        if (valid) {
          // 这里可以替换为接口提交逻辑
          addConsumableAssets(this.materialForm).then(() => {
            this.$message.success("保存成功");
            this.materialDialogVisible = false; // 关闭弹窗
            // 新增成功
            this.resetQuery();
          });
        }
      });
    },
    // 重置
    resetQuery() {
      this.queryParams = { name: "", category: "" };
      this.currentPage = 1;
      this.handleQuery();
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      // 使用 filter 进行模糊查询
      consumableAssetsList({
        page_no: this.currentPage,
        page_size: this.pageSize,
        key_word: this.queryParams.category,
      }).then((res) => {
        // console.log(res);
        this.tableData = res.records;
        this.total = res.total;
      });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: right;
}
</style>
